import React from "react"
import Typography from "@mui/material/Typography"
import { makeStyles } from "@mui/styles"

const useStyles = makeStyles(theme => ({
  beta: {
    border: "1px solid",
    borderColor: theme.palette.primary.main,
    padding: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
    color: theme.palette.primary.main 
  },
}))

const BetaNotice = () => {
  const classes = useStyles()
  return (
    <Typography display="inline" variant="caption" className={classes.beta}>
      BETA
    </Typography>
  )}

export default BetaNotice